import React from "react";

import {
  IsMobile,
  IsNotMobile,
  IsPad,
} from "../../../../components/ResponsiveContainers";
import {
  Container,
  TitleWrap,
  TitleFirst,
  TitleSecond,
  TitleText,
  BgColorDiv,
  SummaryContainer,
  MoreButton,
  ButtonWrap,
} from "./styled";

const ClosetsDescription = () => {
  return (
    <Container>
      <TitleWrap>
        <TitleFirst>
          <BgColorDiv />
          <IsNotMobile>
            <TitleText>What can a custom closet</TitleText>
          </IsNotMobile>
          <IsMobile>
            <TitleText>What can a custom closet</TitleText>
          </IsMobile>
        </TitleFirst>
        <TitleSecond>
          <BgColorDiv />
          <IsNotMobile>
            <TitleText>do for me?</TitleText>
          </IsNotMobile>
          <IsMobile>
            <TitleText>closet do for me?</TitleText>
          </IsMobile>
        </TitleSecond>
      </TitleWrap>
      <SummaryContainer>
        Begin your day by walking into an organized wardrobe and notice how the
        rest of your day just flows. When you know where to find your clothing
        and when it is easily accessible you save yourself time and stress.
        Closets don’t only have to be functional, they can be just as unique as
        you are. Speak with one of our designers and see what kind of beauty can
        be created.
      </SummaryContainer>
      <ButtonWrap>
        <MoreButton ptype="default" pname="VIEW CLOSETS"/>
      </ButtonWrap>
    </Container>
  );
};

export default ClosetsDescription;
